import { useState, useEffect } from 'react';
import api from '../api';
import Segmented from '../components/Segmented';

const ACCIONES = {
  LOGIN:          { emoji: '🔐', label: 'Inicio de sesión',     color: 'var(--accent-solid)' },
  LANZAR_CAMPANA: { emoji: '', label: 'Campaña lanzada',       color: 'var(--success)' },
  RECARGAR_SALDO: { emoji: '💳', label: 'Recarga de saldo',      color: 'var(--warning)' },
  CONFIG_CAMBIO:  { emoji: '',  label: 'Cambio de configuración', color: 'var(--accent-2)' },
  USUARIO_CREADO: { emoji: '👤', label: 'Usuario creado',        color: 'var(--accent-solid)' },
  USUARIO_EDITADO:{ emoji: '👤', label: 'Usuario modificado',    color: 'var(--accent-2)' },
};

export default function Activity() {
  const [logs, setLogs]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro]   = useState('');

  useEffect(() => {
    api.get('/audit/logs?limit=50')
      .then(r => setLogs(r.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const logsFiltrados = filtro ? logs.filter(l => l.accion === filtro) : logs;

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontFamily: 'Inter,sans-serif', fontSize: 22, fontWeight: 700, color: 'var(--text)' }}>Actividad</h1>
        <p style={{ color: 'var(--text-3)', fontSize: 13, marginTop: 4 }}>Historial de acciones en tu cuenta</p>
      </div>

      {/* Filtros */}
      <div style={{ marginBottom: 20 }}>
        <Segmented size="sm"
          options={[{ value: '', label: 'Todos' }, ...Object.entries(ACCIONES).map(([key, val]) => ({ value: key, label: val.label }))]}
          value={filtro} onChange={setFiltro} />
      </div>

      {/* Lista */}
      <div className="ic-card" style={{ background: 'var(--bg)', border: '1px solid var(--surface)', borderRadius: 12, overflow: 'hidden' }}>
        {loading && <div style={{ padding: 24, color: 'var(--text-3)', fontSize: 13 }}>Cargando...</div>}
        {!loading && logsFiltrados.length === 0 && (
          <div style={{ padding: 24, color: 'var(--text-3)', fontSize: 13, textAlign: 'center' }}>Sin actividad registrada</div>
        )}
        {logsFiltrados.map((log, i) => {
          const info = ACCIONES[log.accion] || { emoji: '•', label: log.accion, color: 'var(--text-3)' };
          const fecha = new Date(log.fecha);
          const detalle = log.detalle || {};
          return (
            <div key={i} style={{
              display: 'flex', alignItems: 'center', gap: 16, padding: '14px 20px',
              borderBottom: i < logsFiltrados.length - 1 ? '1px solid var(--surface-3)' : 'none',
            }}>
              <div style={{
                width: 36, height: 36, borderRadius: 10, display: 'flex', alignItems: 'center',
                justifyContent: 'center', fontSize: 16, flexShrink: 0,
                background: `${info.color}15`, border: `1px solid ${info.color}30`,
              }}>{info.emoji}</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text)' }}>{info.label}</div>
                <div style={{ fontSize: 11, color: 'var(--text-3)', marginTop: 2 }}>
                  {log.accion === 'LOGIN' && `Desde ${log.ip}`}
                  {log.accion === 'LANZAR_CAMPANA' && `${detalle.contactos || 0} contactos · ${detalle.concurrencia || 0} simultáneas`}
                  {log.accion === 'RECARGAR_SALDO' && `$${(detalle.monto || 0).toLocaleString('es-CO')} COP`}
                  {log.accion === 'CONFIG_CAMBIO' && `Campos: ${(detalle.campos || []).join(', ')}`}
                  {log.accion === 'USUARIO_CREADO' && `${detalle.nombre || ''} · ${detalle.correo || ''} · ${detalle.rol || ''}`}
                  {log.accion === 'USUARIO_EDITADO' && `${detalle.correo || ''} · ${(detalle.campos || []).join(', ')}`}
                  {detalle.usuario && <span style={{ color: 'var(--text-2)', fontWeight: 600 }}> · por {detalle.usuario}</span>}
                </div>
              </div>
              <div style={{ fontSize: 11, color: 'var(--text-3)', textAlign: 'right', flexShrink: 0 }}>
                <div>{fecha.toLocaleDateString('es-CO', { day: '2-digit', month: 'short', year: 'numeric' })}</div>
                <div style={{ marginTop: 2 }}>{fecha.toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' })}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
